export function Loading() {
  return (
    <div className="h-full w-full flex-shrink flex items-center justify-center">
      <div className="loader ease-linear rounded-full border-4 border-t-4 border-blue-500 h-10 w-10"></div>
    </div>
  );
}
